import { initComponent } from './core/init-component.js'

initComponent('.js-pdp-sticky-atc', section => {

  // Move sticky ATC to body for sticky positioning
  if (section) {
    document.body.appendChild(section)
  }
  const stickyAtc = section
  const productForm = document.querySelector('.js-pdp-atc-form')
  const footer = document.querySelector('.js-footer')

  if (!stickyAtc || !productForm) return

  const initialFormRect = productForm.getBoundingClientRect()
  let isFormBelowViewport = initialFormRect.bottom < 0
  let isFooterVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight && footer.getBoundingClientRect().bottom > 0 : false

  if (stickyAtc && productForm && 'IntersectionObserver' in window) {
    const formObserver = new IntersectionObserver(
      ([entry]) => {
        const rect = productForm.getBoundingClientRect()
        isFormBelowViewport = rect.bottom < 0
        updateStickyVisibility()
      },
      {
        threshold: 0,
      }
    )

    formObserver.observe(productForm)

    let footerObserver = null
    if (footer) {
      footerObserver = new IntersectionObserver(
        ([entry]) => {
          isFooterVisible = entry.isIntersecting
          updateStickyVisibility()
        },
        {
          threshold: 0,
          rootMargin: '0px'
        }
      )

      footerObserver.observe(footer)
    }

    function updateStickyVisibility() {
      const shouldShow = isFormBelowViewport && !isFooterVisible
      stickyAtc.classList.toggle('translate-y-0', shouldShow)
      stickyAtc.classList.toggle('translate-y-[200%]', !shouldShow)
    }

    updateStickyVisibility()

    return {
      unload() {
        formObserver?.disconnect()
        footerObserver?.disconnect()
      }
    }
  }
})